import i18n from "../../i18n";
const state = {
  deviceExceptions: [],
  deviceExceptionsByDeviceId: [],
  deviceExceptionRules: [],
  deviceExceptionsData: {
    fields: [
      { value: "name", text: i18n.t("Exception Name"), sortable: true },
      {
        value: "description",
        text: i18n.t("Exception Description"),
        sortable: true,
      },
      {
        value: "created_at",
        text: i18n.t("Created Date"),
        sortable: true,
      },
      {
        value: "updated_at",
        text: i18n.t("Modified Date"),
        sortable: true,
      },
      {
        value: "devices",
        text: i18n.t("Device Count"),
        sortable: true,
      },
      {
        value: "rules",
        text: i18n.t("Rule Count"),
        sortable: true,
      },
      { value: "actions", sortable: false },
    ],
    items: [],
  },
  deviceExceptionRulesData: {
    fields: [
      {
        value: "domain",
        text: i18n.t("Domain Name"),
        sortable: true,
      },
      {
        value: "ip",
        text: i18n.t("Source IP"),
        sortable: true,
      },
      {
        value: "resolver",
        text: i18n.t("Resolver"),
        sortable: true,
      },
      {
        value: "rule_type",
        text: i18n.t("Rule Type"),
        sortable: true,
      },
      {
        value: "description",
        text: i18n.t("Description"),
        sortable: true,
      },
      {
        value: "created_at",
        text: i18n.t("Created Date"),
        sortable: true,
      },
      {
        value: "updated_at",
        text: i18n.t("Modified Date"),
        sortable: true,
      },
    ],
    items: [],
  },
};

const getters = {
  deviceExceptions: (state) => state.deviceExceptionsData.items,
  deviceExceptionsByDeviceId: (state) => state.deviceExceptionsByDeviceId,
  deviceExceptionRules: (state) => state.deviceExceptionRules,
};

const actions = {
  // DEVICE EXCEPTIONS endpoints
  async createDeviceException({ commit }, { userId, body }) {
    const withUser = userId ? `?user_id=${userId}` : ``;
    const requestURL = `/restapi/device_exceptions${withUser}`;
    const response = await this._vm.$http.post(requestURL, body);
    commit("addDeviceException", response.data);
    return response.data;
  },

  async updateDeviceException({ commit, state }, { id, body }) {
    const response = await this._vm.$http.put(
      `/restapi/device_exceptions/${id}`,
      body
    );
    const index = state.deviceExceptions.findIndex(
      (deviceException) => deviceException.id === response.data.id
    );
    commit("updateDeviceException", {
      idx: index,
      deviceException: response.data,
    });
    return response.data;
  },

  async deleteDeviceExceptions({ commit }, { exceptions }) {
    const req = {};
    for (const deviceException of exceptions) {
      req[`${deviceException.id}`] = {
        method: "delete",
        path: `device_exceptions/${deviceException.id}`,
      };
    }
    const res = await this._vm.$http.post("/restapi/batch", req);
    const ids = Object.keys(res.data).map((item) => +item);
    commit("deleteDeviceExceptions", ids);
  },

  async fetchDeviceExceptions({ commit }, { userId }) {
    if (userId) {
      const withUser = userId ? `?user_id=${userId}` : ``;
      const requestURL = `/restapi/device_exceptions${withUser}`;
      const response = await this._vm.$http.get(requestURL);
      commit("setDeviceExceptions", response.data);
    }
  },

  async fetchDeviceExceptionsByDeviceId({ commit }, { deviceId }) {
    const requestURL = `/restapi/device_exceptions/${deviceId}`;
    const response = await this._vm.$http.get(requestURL);
    commit("setDeviceExceptionsByDeviceId", response.data);
  },

  // DEVICE EXCEPTION RULES endpoints
  async fetchDeviceExceptionRules({ commit }, { userId, exceptionId }) {
    const withUser = userId ? `?user_id=${userId}` : ``;
    const requestURL = `/restapi/device_exceptions/${exceptionId}/rules${withUser}`;
    const response = await this._vm.$http.get(requestURL);
    commit("setDeviceExceptionRules", response.data);
  },

  async createDeviceExceptionRule({ commit }, { userId, exceptionId, body }) {
    const withUser = userId ? `?user_id=${userId}` : ``;
    const requestURL = `/restapi/device_exceptions/${exceptionId}/rules${withUser}`;
    const response = await this._vm.$http.post(requestURL, body);
    commit("addDeviceExceptionRule", response.data.device_exception_rule);
    return response.data.device_exception_rule;
  },

  async updateDeviceExceptionRule({ commit }, { id, exceptionId, body }) {
    const response = await this._vm.$http.put(
      `/restapi/device_exceptions/${exceptionId}/rules/${id}`,
      body
    );
    const index = state.deviceExceptionRules.findIndex(
      (deviceExceptionRule) => deviceExceptionRule.id === response.data.id
    );
    commit("updateDeviceExceptionRule", {
      idx: index,
      deviceExceptionRule: response.data,
    });
    return response.data;
  },

  async deleteDeviceExceptionRules({ commit }, { exceptionId, rules }) {
    const req = {};
    for (const deviceExceptionRule of rules) {
      req[`${deviceExceptionRule.id}`] = {
        method: "delete",
        path: `device_exceptions/${exceptionId}/rules/${deviceExceptionRule.id}`,
      };
    }
    const res = await this._vm.$http.post("/restapi/batch", req);
    const ids = Object.keys(res.data).map((item) => +item);
    commit("deleteDeviceExceptionRules", ids);
  },
};

const mutations = {
  addDeviceException: (state, data) =>
    state.deviceExceptionsData.items.push(data),
  deleteDeviceExceptions(state, deviceExceptions) {
    for (const deviceException of deviceExceptions) {
      state.deviceExceptionsData.items =
        state.deviceExceptionsData.items.filter(
          (stateDeviceException) => stateDeviceException.id !== deviceException
        );
    }
  },
  updateDeviceException(state, data) {
    state.deviceExceptionsData.items = state.deviceExceptionsData.items.map(
      (obj) => [data].find((o) => o.id === obj.id) || obj
    );
  },
  setDeviceExceptions: (state, data) =>
    (state.deviceExceptionsData.items = data.data),
  setDeviceExceptionsByDeviceId: (state, data) =>
    (state.deviceExceptionsByDeviceId = data.data),
  addDeviceExceptionRule: (state, data) =>
    state.deviceExceptionRulesData.items.push(data),
  setDeviceExceptionRules: (state, data) =>
    (state.deviceExceptionRulesData.items = data.data),
  updateDeviceExceptionRule(state, data) {
    state.deviceExceptionRulesData.items =
      state.deviceExceptionRulesData.items.map(
        (obj) => [data].find((o) => o.id === obj.id) || obj
      );
  },
  deleteDeviceExceptionRules(state, deviceExceptionRules) {
    for (const deviceExceptionRule of deviceExceptionRules) {
      state.deviceExceptionRulesData.items =
        state.deviceExceptionRulesData.items.filter(
          (stateDeviceExceptionRule) =>
            stateDeviceExceptionRule.id !== deviceExceptionRule
        );
    }
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
